import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { post, startGuestSession } from '../api';

// Public landing page for logged-out visitors (see App.tsx's root route).
// "Start Campaign" is the whole point of this page: skip the signup wall
// entirely by creating a guest account behind the scenes and dropping the
// player straight into the first mission, mirroring the same
// guest-session -> mission-start -> navigate sequence used by
// campaign.page.tsx/my-games.page.tsx for an already-authenticated user.
const FIRST_MISSION_ID = 'the-ford';

export default function HomePage() {
  const [starting, setStarting] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleStartCampaign = async () => {
    setError('');
    setStarting(true);
    try {
      const ok = await startGuestSession();
      if (!ok) {
        setError('Could not start campaign. Please try again.');
        return;
      }
      const result = await post(`missions/${FIRST_MISSION_ID}/start`, {});
      navigate(`/games/${result.id}?from=campaign`);
    } catch {
      setError('Could not start campaign. Please try again.');
    } finally {
      setStarting(false);
    }
  };

  return (
    <div className="columns">
      <div className="column is-half is-offset-one-quarter has-text-centered">
        <h1 className="title">BannerWars</h1>
        <p className="subtitle">Turn-based tactics.</p>

        <button
          className={`button is-primary is-large${
            starting ? ' is-loading' : ''
          }`}
          onClick={handleStartCampaign}
          disabled={starting}
        >
          Start Campaign
        </button>
        {error && <p className="has-text-danger mt-3">{error}</p>}

        <p className="mt-5">
          Already have an account? <Link to="/login">Log in</Link> or{' '}
          <Link to="/register">register here</Link>.
        </p>
      </div>
    </div>
  );
}
